module.exports = __webpack_public_path__ + "img/1.8470ce21.png";